import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => ({
  badge: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.light,
  },
}));
